import * as React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalChildStyle } from './modal';
import { style } from 'typestyle';
import { colorBrand, colorContrast } from '../theme/color';
import { px } from 'csx';
import { TextNoOrphan } from './text-no-orphan';
import { FormOnboarding, FormOnboardingFields } from './form-onboarding';
import { resetAnchorStyles } from '../theme/reset';
import {FieldValues} from '../types/form';
import {UIHeroGenre} from '../types/ui';

export interface OnboardingModalModel {
  show: boolean;
  saving: boolean;
  error: string;
  defaultValues?: FieldValues<FormOnboardingFields>;
  genres: Array<UIHeroGenre>;
}

export interface OnboardingModalProps {
  onRequestClose(): void;
  onSubmit(fields: FormOnboardingFields): void;
  onClickLink(event: React.MouseEvent<any>): void;
  model: OnboardingModalModel;
  i18n?: {
    title: string;
    strap: string;
    tandc: string;
  }
}

const DEFAULT_I18N = {
  title: 'Nearly there!',
  strap: 'We just need a few more details from you in order to work out your price band',
  tandc: 'View terms and conditions'
};

@observer
export class OnboardingModal extends React.Component<OnboardingModalProps, {}> {
  render() {
    const {
      onSubmit,
      onRequestClose,
      onClickLink,
      model,
      i18n = DEFAULT_I18N,
    } = this.props;

    return (
      <Modal show={model.show} onRequestClose={onRequestClose}>
        {model.show && (
          <div className={OnboardingModal.styles.container}>
            <h3>
              <TextNoOrphan value={i18n.title} />
            </h3>
            <p>{i18n.strap}</p>
            <FormOnboarding
              onSubmit={onSubmit}
              onCancel={onRequestClose}
              error={model.error}
              saving={model.saving}
              defaultValues={model.defaultValues}
              genres={model.genres}
            />
            <a className={OnboardingModal.styles.link} href="/terms-and-conditions" onClick={onClickLink}>
              {i18n.tandc}
            </a>
          </div>
        )}
      </Modal>
    )
  }

  static styles = {
    container: style({
      ...ModalChildStyle,
      position: 'relative',
      width: px(320),
      $nest: {
        '&> h3': {
          color: colorBrand.toString(),
          fontSize: px(30),
          margin: 0,
        },
        '&> p': {
          margin: '30px 0 20px 0',
        }
      }
    }),
    link: style({
      position: 'absolute',
      bottom: px(70),
      left: px(60),
      fontSize: px(12),
      color: colorBrand.toString(),
      $nest: {
        ...resetAnchorStyles(colorBrand.toString())
      }
    })
  }
}